module.exports = __webpack_public_path__ + "static/media/search-input.94308abc.svg";